export const BASE_APP_PATH = '/app';
export const privateAppPath = (url) => `${BASE_APP_PATH}/${url}`;

export const LOGIN_PAGE = '/login';
export const ACTIONS_PAGE = '/actions';
export const privateActionsPath = (url) => `${ACTIONS_PAGE}/${url}`;
